// extracted by mini-css-extract-plugin
export var bar = "featuredRecipe-module--bar--ef970";
export var featuredRecipeTitle = "featuredRecipe-module--featured-recipe-title--14b6a";
export var featured_recipe_container = "featuredRecipe-module--featured_recipe_container--4dad4";
export var recipe_img = "featuredRecipe-module--recipe_img--111b9";
export var recipe_img_wrapper = "featuredRecipe-module--recipe_img_wrapper--b7f73";
export var subTitle = "featuredRecipe-module--sub-title--7e34f";